export default {
  id: "social-calendar",
  name: "Social Calendar",
  shortName: "Social",
  description: "Social media calendar & scheduling",
  icon: "megaphone",
  color: "#F18F01",
  roles: ["super_admin", "admin", "corporate", "marketing_agency"],
  css: "styles/apps/social-calendar.css?v=88",
  nav: [
    { id: "calendar", label: "Calendar" },
    { id: "approvals", label: "Approvals" },
  ],
  defaultView: "calendar",
};
